import classes from './PopinTitle.module.css';

interface props {
  readonly text: string
}

export default function PopinTitle({text}:props){
  return <div className={classes.title}>{text}</div>;
}